export default function Footer() {
  return <h1>Footer</h1>;
}
